import Component from '@glimmer/component';
import { action } from '@ember/object';
import ENV from 'seshy/config/environment';
import { service } from '@ember/service';

export default class NewTeamButtonComponent extends Component {
  @service platform;

  @action
  openNewTeamPage(e) {
    e.preventDefault();
    var page = ENV.api.webhost + '/account/teams/new';
    console.log('yo', page);
    this.platform.openUrl(page);
  }
}
